import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputSelectSF from '../../../widgets/form/InputSelectSF'

const SendToZybraModalUI = ({
  context, successMsg, errorList, setErrorList,
  updateMode, submitted, onSubmit, onCancelClick,
  customer, onCustomerChange, customerError, setCustomerError, optionList
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Send to Zybra'
    buttonLabel='Send'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputSelectSF type='select' name='customer' label='Customer'
      value={customer} onChange={onCustomerChange} optionList={optionList}
      error={customerError} setError={setCustomerError}
    />
  </ModalFormUI>

export default SendToZybraModalUI
